import type { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import { usePermissions } from '../../../../../hooks/usePermissions';
import { useSpacePath } from '../../../../../hooks/useSpacePath';
import type { DisplayedSubjectQuote } from '../../../../../types';

export type QuoteCardProps = {
  quote: DisplayedSubjectQuote;
  onEdit: (quote: DisplayedSubjectQuote) => void;
  onDelete: (quote: DisplayedSubjectQuote) => void;
  onAccept: (quote: DisplayedSubjectQuote) => void;
  onRefuse: (quote: DisplayedSubjectQuote) => void;
  onResetToPending: (quote: DisplayedSubjectQuote) => void;
  onAttachSignedDocument?: (quote: DisplayedSubjectQuote) => void;
};

export function useQuoteCard(props: QuoteCardProps) {
  const { isAdmin } = usePermissions();
  const spacePath = useSpacePath();
  const navigate = useNavigate();

  const providerHref = props.quote.provider_id
    ? spacePath(`/providers/${props.quote.provider_id}`)
    : undefined;

  function handleProviderClick(event?: MouseEvent<HTMLElement | HTMLAnchorElement>) {
    if (
      providerHref &&
      event &&
      event.button === 0 &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey
    ) {
      event.preventDefault();
      navigate(providerHref);
    }
  }

  function handleEdit() {
    props.onEdit(props.quote);
  }

  function handleDelete() {
    props.onDelete(props.quote);
  }

  function handleAccept() {
    props.onAccept(props.quote);
  }

  function handleRefuse() {
    props.onRefuse(props.quote);
  }

  function handleResetToPending() {
    props.onResetToPending(props.quote);
  }

  function handleAttachBpa() {
    props.onAttachSignedDocument?.(props.quote);
  }

  return {
    isAdmin,
    providerHref,
    handleProviderClick,
    handleEdit,
    handleDelete,
    handleAccept,
    handleRefuse,
    handleResetToPending,
    handleAttachBpa,
  };
}
